import { Spinner } from '@arpeggi/ui'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useArpCollaborators } from '../hooks'
import { Contributors } from '../primitives'

export const ArpContributorsSection: FC<{ media: IArpMedia }> = ({ media }) => {
  const { data, status } = useArpCollaborators(media)
  if (status !== 'ready')
    return (
      <Contributors.Root>
        <Spinner />
      </Contributors.Root>
    )
  return (
    <Contributors.Root>
      <Contributors.AvatarGroup>
        {data.map((user) => (
          <Contributors.Avatar key={user.walletAddress} src={user.profilePicture?.url} />
        ))}
      </Contributors.AvatarGroup>
      <Link to={`?token=${media.id}#details`} relative={'path'} replace>
        <Contributors.Count>{`${data.length} contributors`}</Contributors.Count>
      </Link>
    </Contributors.Root>
  )
}
